module.exports = __webpack_public_path__ + "img/danmati_loading.3496418d.gif";